





















































































































































































































































































import { Contact, Link, Member, Statement, Submission, Tag, Work } from "@/api/models";
import {
  CourseItem,
  defaultSimpleProject,
  SiteState,
  SubmissionState,
  SubNavItem,
  UserState,
} from "@/store/types";
import { Component, Vue, Watch } from "vue-property-decorator";
import { Action, State } from "vuex-class";
import deepEqual from "deep-equal";
import {
  checkRemoteUpdatedSub,
  fetchTags,
  getRemoteSubmission,
  saveSubmission,
  testSlug,
} from "../api/methods";
import {
  emptyString,
  isNumeric,
  notEmptyLinkField,
  notEmptyString,
  validContact,
  validCourseCode,
  validEmail,
  validLinkField,
} from "../api/validators";
import TagField from "./widgets/TagField.vue";
import LinkField from "./widgets/LinkField.vue";
import MemberField from "./widgets/MemberField.vue";
import ContactField from "./widgets/ContactField.vue";
import WorkForm from "./WorkForm.vue";
import Overview from "./Overview.vue";
import UploadForm from "./widgets/UploadForm.vue";
import StatementField from "./widgets/StatementField.vue";
import SubmissionNav from "./widgets/SubmissionNav.vue";
import SubmissionSort from "./widgets/SubmissionSort.vue";
import HelpWidget from "./widgets/HelpWidget.vue";
import SnippetItem from "./widgets/SnippetItem.vue";
import ThemeTree from "./widgets/ThemeTree.vue";
import MemberView from "./widgets/MemberView.vue";
import DisplayOptionSet from "./widgets/DisplayOptionSet.vue";
import ProjectInfo from "./widgets/ProjectInfo.vue";
import { captureHashTags, enableProfileTags, showSponsorsField, requireSponsorUrl, statements } from "../.config";
import { bus } from "@/main";
import { hasErrorInSection, validateSectionDom } from "@/api/dom";
import { extractProfileObject } from "@/api/extract-entries";
import { extractTagItems } from "@/api/expand-tags";
import { ErrorInfo } from "@/api/interfaces";
import { sanitize } from "@/api/helpers";

@Component({
  name: "SubmissionMain",
  components: {
    TagField,
    ThemeTree,
    StatementField,
    DisplayOptionSet,
    WorkForm,
    MemberField,
    LinkField,
    ContactField,
    UploadForm,
    Overview,
    SubmissionNav,
    SubmissionSort,
    MemberView,
    SnippetItem,
    HelpWidget,
    ProjectInfo
  },
  filters: {},
})
export default class SubmissionMain extends Vue {
  @State("site") site: SiteState;
  @State("user") user: UserState;
  @State("submission") submission: SubmissionState;
  @Action("assignSubmission", { namespace: "submission" })
  assignSubmission: Function;
  @Action("assignProject", { namespace: "site" })
  assignProject: Function;

  // suggested tags used in work containers passed down by reference
  tagList: Array<Tag> = [];
  // show extra work nav item for an unsaved new work
  showNewWork = false;

  // selected work index or -1 if no work is selected
  workIndex = -1;

  prevKey = "start";

  // id selected media item (for editing in the upload form)
  mediaItemId = "";

  // show the overview tab if the form as the min. required sections completed
  showOverview = false;

  // show the work sort widget
  showSort = false;

  // reference key for the uploaded item, may include the workId or statement type
  uploadRef = "";

  uploadMode = "";

  // Editable link field objects mapped from the global submission object
  memberFields: Array<Member> = [];
  linkFields: Array<Link> = [];
  sponsorFields: Array<Link> = [];
  // private eventFields: Array<Link> = [];
  // Extra editable contact mapped from the main submission
  contactFields: Array<Contact> = [];
  courseItem: CourseItem = { code: "", name: "", parent: "" };

  // Set to true when an editable item changes, prompting a save
  changeDetected = false;

  changeChecked = false;

  // When true, saving is blocked. This prevents repeated save events
  saving = false;

  saveLocked = false;

  showingToast = false;

  redirecting = false;

  detecting = false;

  dialogue = null;

  programmeLocked = false;

  slugLocked = false;

  showSlugError = false;

  created() {
    this.retrieveTags();
    this.sync();
    this.matchPath();
    this.mediaItemId = "";
    
    bus.$on("upload-ref", ({ refKey, type, mode }) => {
      switch (type) {
        case "work":
          this.setUploadRef("work", refKey, mode);
          break;
        case "statement":
          this.setUploadRef(refKey);
          break;
      }
      if (refKey.length < 2) {
        this.uploadRef = refKey;
      }
      bus.$emit("open-help", "all");
    });
    bus.$on("escape", this.escapeAll);
    bus.$on("hide-sort", () => {
      this.showSort = false;
    });
    bus.$on("goto", (next, skipValidate) => {
      this.goTo(next, false, skipValidate);
      this.escape(false);
    });
    bus.$on("save", ({ msg, delay, saveWork }) => {
      if (!this.saving && !this.saveLocked && !this.showIneligible) {
        this.save(delay, msg, saveWork === true);
      }
      if (saveWork === true) {
        if (this.workId.length > 12) {
          bus.$emit("save-work", { workId: this.workId });
        }
      }
    });
    bus.$on("work-saved", ({ title, index }) => {
      this.showNewWork = false;
      const msg = `${this.site.label("submission__works")} ${index +
        1}: ${title} saved`;
      this.toast(msg, 3000);
    });
    bus.$on("sort-works", ({ oldWorkIndex, newWorkIndex }) => {
      if (
        oldWorkIndex >= 0 &&
        oldWorkIndex < this.numWorks &&
        newWorkIndex >= 0 &&
        newWorkIndex < this.numWorks &&
        newWorkIndex !== oldWorkIndex &&
        !this.showIneligible
      ) {
        const refWork = this.submission.works.splice(oldWorkIndex, 1)[0];
        this.submission.works.splice(newWorkIndex, 0, refWork);
        this.assignSubmission(this.submission);
        this.save(0, "", false);
      }
    });
    bus.$on("published", () => {
      this.toast("Your submission has been submitted for publication", 3000);
    });
    bus.$on("link-field-removed", ({ fieldName }) => {
      if (notEmptyString(fieldName)) {
        this.saveDetails();
      }
    });
    bus.$on("delete-member", ({index}: {index: number}) => {
      if (index > 0) {
        this.memberFields.splice(index, 1);
      }  
    });
    bus.$on('update-member', ({index, member}: {index: number; member: Member}) => {
      if (index >= 0 && member instanceof Object) {
        if (index < this.memberFields.length) {
          const updatedMember = new Member(member);
          this.memberFields[index] = updatedMember;
          this.submission.members[index] = updatedMember;
        }
      }
    });
    bus.$on("bad-file", (msg = "") => {
      const message = notEmptyString(msg, 5) ? msg : `Invalid file.`;
      this.toast(message, 2000, "danger");
    });
    bus.$on("save-locked", (ok: boolean) => {
      if (ok) {
        this.saveLocked = true;
        this.toast(this.site.label("work__add_title"), 5000, "info");
      }
    });
    bus.$on("unlock", (ok: boolean) => {
      if (ok) {
        this.saveLocked = false;
      }
    });

    bus.$on("show-message", ({workId, index, msg}: {workId: string; index: number; msg: string}) => {
      if (index >= 0 && workId === this.workId) {
        this.alertMsg(msg, 'danger');
        this.goToError();
      }
    });
    setTimeout(this.checkSubmissionStatus, 1000);
    setInterval(this.checkSubmissionStatus, 30 * 60 * 1000);
    setInterval(() => {
      const { path } = this.$route;
      //if (this.changeDetected && path.includes("start")) {
      if (path.includes("start")) {
        //this.saveDetails();
        //this.changeDetected = false;
        this.detectChange();
      }
    }, 15 * 1000);
    this.programmeLocked = this.hasProgramme === true && this.hasSchool;
  }

  beforeDestroy() {
    this.disableEvents();
  }

  disableEvents() {
    bus.$off("show-message");
  }

  get hasProgramme() {
    return notEmptyString(this.submission.programmeCode, 4);
  }

  get schoolOpts() {
    return [{key: '-', name: '[none]', groups: []}, ...this.site.schools.filter(s => s.key !== 'ilts')]
  }

  get selectedSchoolGroups() {
    const simpleName = this.hasSchool ? sanitize(this.submission.school) : '';
    const row = this.hasSchool ? this.site.schools.find(sc => sanitize(sc.name) === simpleName) : null;
    if (row instanceof Object) {
      return row.groups;
    } else {
      return [];
    }
  }

  get programmeOpts() {
    const grs = this.selectedSchoolGroups;
    const hasGroups = grs.length > 0;
    return [{key: '-', name: '[none]', groups: []}, ...this.site.programmes.filter(p => !hasGroups || grs.some(g => p.key.startsWith(g)) )]
  }

  get mode() {
    return this.site.mode;
  }

  get excludedSlugs() {
    return this.isGroupMode ? this.submission.selectedThemeSlugs : [];
  }

  get isGroupMode() {
    return this.mode === 'group';
  }

  get enableContainers() {
    return this.isGroupMode || this.site.settings.get('enable_student_containers') === true;
  }

  get showSponsors() {
    return !this.isGroupMode && showSponsorsField;
  }

  get showSchool() {
    return !this.isGroupMode;
  }

  get showProgramme() {
    return !this.isGroupMode;
  }

  get showCourse() {
    return !this.isGroupMode;
  }

  get showDescription() {
    return this.isGroupMode;
  }

  get showSlugField() {
    return this.isGroupMode;
  }

  get slugLockHint() {
    return this.slugLocked ? 'Unlock slug' : 'Lock slug';
  }

  get slugErrorMessage() {
    if (notEmptyString(this.submission.slug) && this.showSlugError) {
      return `The above slug has been allocated. Please choose a unique slug for the project's URL`;
    } else {
      return `Please enter a slug for the project's URL`;
    }
  }

  get hasDisplayOptions() {
    const dsOpts = this.site.displayOptions.get('submission');
    return dsOpts instanceof Array && dsOpts.length > 0;
  }

  get leadMember(): Member {
    if (this.submission.members.length > 0) {
      const member = this.submission.members.find(row => row.identifier.toLowerCase() === this.user.identifier.toLowerCase());
      if (member instanceof Member) {
        return member;
      }
    }
    return new Member();
  }

  get displayNameLabel() {
    const key = this.isGroupMode ? 'submission__project_title_label' : 'submission__display_name_label';
    return this.site.label(key);
  }

  get slugLabel() {
    const slugWord = this.site.label("submission__slug_label");
    const subWord = this.isGroupMode ? 'Project' : 'Student page';
    return `${subWord} ${slugWord.toLowerCase()}`;
  }

  get slugLockIcon() {
    return this.slugLocked ? 'lock': 'lock-open';
  }

  toggleSlugLocked() {
    if (this.slugLocked) {
      /* const newSlug = sanitize(this.submission.displayName, this.maxSlugLength)
      if (newSlug !== this.submission.slug) {
        this.submission.slug = newSlug;
      } */
      this.slugLocked = false;
    } else {
      if (!this.showSlugError && notEmptyString(this.submission.slug, 3)) {
        this.slugLocked = true;
      }
    }
    
  }

  get slugClasses() {
    const cls = [];
    if (this.slugLocked) {
      cls.push('locked');
    } else {
      cls.push('unlocked');
    }
    if (this.showSlugError) {
      cls.push('error');
    } else if (this.submission.slug.length > 3) {
      cls.push('has-slug');
    }
    return cls;
  }

  get tagsEnabled() {
    return enableProfileTags;
  }

  get tagsInputInside() {
    return this.tagsEnabled && statements.length === 1;
  }

  get tagsInputOutside() {
    return this.tagsEnabled && statements.length !== 1;
  }

  get hasSchool() {
    return notEmptyString(this.submission.school, 3);
  }

  // Get the latest submission for the current user if not available
  checkSubmissionStatus() {
    if (!this.isLoggedIn) {
      this.$router.push("/logout");
    } else if (!this.hasSubmission) {
      getRemoteSubmission(this.user._id).then((data) => {
        if (data.valid) {
          this.$ls.set("submission", data);
          this.assignSubmission(data);
          setTimeout(() => {
            this.sync();
            bus.$emit("submission-loaded", true);
          }, 250);
        }
      });
    }
    if (this.showIneligible) {
      this.showOverview = true;
      this.goTo("overview");
    }
    this.saveLocked = false;
    setTimeout(() => {
      if (this.submission.ineligible) {
        this.showOverview = true;
        this.goTo("overview");
      }
    }, 5000);
  }

  updateDisplayOptions(displayOpts = null) {
    if (displayOpts instanceof Object) {
      this.submission.displayOptions = displayOpts;
      this.detectChange();
    }
  }

  updateTheme({themes, subthemes}) {
    this.submission.themes = themes;
    this.submission.subthemes = subthemes;
  }

  displayValidate(valid = true) {
    this.saveLocked = valid === false;
  }

  updateTags() {
    const tags = extractTagItems(this.submission.description);
    const statementTags = extractTagItems(this.statementText);
    const textTags = [...tags, ...statementTags];
    if (textTags.length > 0) {
      textTags.forEach((item: Tag) => {
        const exists = this.submission.tags.some(tg => tg.slug === item.slug);
        if (!exists) {
          this.submission.tags.push(item);
        }
      });
    }
  }


  get statementText() {
    const textItems = this.submission.statements.map(item => notEmptyString(item.text) ? item.text : '');
    return textItems.join('\n');
  }

  get hasSubmission() {
    return notEmptyString(this.submission._id, 12);
  }

  get courses() {
    const { programmeCode } = this.submission;
    const hasFilter = notEmptyString(programmeCode, 2);
    const ucParCode = hasFilter ? programmeCode.toUpperCase() : '';
    /* const shortParCode = ucParCode.replace(/-\dYR$/i, '');
    return this.site.courses.filter((cs) => {
      return hasFilter
        ? [ucParCode, shortParCode].includes(cs.parent.toUpperCase())
        : true;
    }); */
    return this.site.courses.filter((cs) => {
      return hasFilter
        ? ucParCode === cs.parent.toUpperCase()
        : true;
    });
  }

  get isLoggedIn() {
    return notEmptyString(this.user._id, 12) && this.user.active === true;
  }

  get isOpen() {
    return this.site.settings.get("submissions_open");
  }

  get deadline() {
    return new Date(this.site.settings.get("submissions_deadline"));
  }

  get mayEdit() {
    const nowTs = new Date().getTime();
    const deadlineTs = this.deadline.getTime();
    return (
      this.isOpen &&
      (nowTs < deadlineTs || this.submission.deadlineException) &&
      this.submission.ineligible === false
    );
  }

  get showIneligible() {
    return this.submission.ineligible === true;
  }

  get introSnippetKey() {
    if (this.isOpen) {
      return "instructions";
    } else {
      return "closed_intro";
    }
  }

  get mayShowQrCode() {
    return this.submission.showQrCode === true;
  }

  get dragHelp() {
    const row = this.site.snippets.find((row) => row.key === "work__sort_help");
    return row instanceof Object ? row.value : "";
  }

  get validDisplayName() {
    return notEmptyString(this.submission.displayName) && !/\[.*?\]/.test(this.submission.displayName);
  }

  get validMainDescription() {
    return notEmptyString(this.submission.description);
  }

  get displayNameClasses() {
    const statusClass = this.validDisplayName ? 'valid' : 'error';
    return ['required', statusClass];
  }

  get straplineClasses() {
    const statusClass = this.validMainDescription ? 'valid' : 'error';
    return ['required', statusClass];
  }

  checkDisplayName() {
    if (!this.validDisplayName) {
      this.submission.displayName = '';
    }
  }

  matchPath() {
    const { path } = this.$route;
    if (!this.mayEdit) {
      this.goTo("overview");
    } else if (path.length > 2) {
      const parts = path.substring(1).split("/");
      if (parts.length < 2) {
        this.goTo(parts[0]);
      } else {
        if (parts[0] === "work") {
          if (isNumeric(parts[1])) {
            const num = parseInt(parts[1], 10);
            const wi = num - 1;

            if (wi >= 0 && wi < this.submission.works.length) {
              const w = this.submission.works[wi];
              if (w instanceof Work) {
                this.goTo(`work-${w._id}-${wi}`);
              }
            }
          }
        }
      }
    }
  }

  get maxWorks() {
    const max = this.site.setting("max_works_per_submission");
    return max > 0 ? max : 5;
  }

  get maxSlugLength() {
    return 40;
  }

  /* Map the notional work containers to the top navigation.
   These may include a temporary unsaved work. */
  get workItems() {
    const items = this.submission.works.map((work, workIndex) => {
      return {
        id: work._id,
        key: ["work", work._id, workIndex].join("-"),
        index: workIndex,
        num: workIndex + 1,
        title: work.title,
      };
    });
    if (this.showNewWork && items.length < this.maxWorks) {
      const nextIndex = items.length;
      items.push({
        id: "_",
        key: ["work", "new", nextIndex].join("-"),
        index: nextIndex,
        num: nextIndex + 1,
        title: "New container...",
      });
    }
    return items;
  }

  /* Should the student details form be available */
  get showStart() {
    return this.workIndex < 0 && !this.showOverview && this.mayEdit;
  }

  /* Should a course dropdown be available */
  get showCourses() {
    return this.courses.length > 0;
  }

  /* Should the course field be read-only */
  get mayNotEditCourse() {
    return (
      notEmptyString(this.submission.courseCode, 5) &&
      this.submission.courseCode.split("-").length > 4
    );
  }

  get introTitleKey() {
    return this.isGroupMode ? "submission__project" : "submission__profile";
  }

  /* fetch top navigation items */
  get submissionNavItems() {
    const items: Array<SubNavItem> = [];
    if (this.mayEdit) {
      items.push({
        name: this.site.label(this.introTitleKey),
        key: "start",
        active: this.showStart,
        icon: "",
      });
      if (this.numWorks > 1 && this.enableContainers) {
        items.push({
          name: `previous`,
          key: `prev`,
          active: false,
          icon: "arrow-left-bold",
        });
      }
      const workWord =
        this.numWorks === 1
          ? "Container"
          : this.site.label("submission__works");
      const numWorks =
        this.workNum > this.numWorkRefs ? this.workNum : this.numWorkRefs;
      const numPart =
        this.workIndex >= 0
          ? this.numWorks > 1
            ? [this.workNum, numWorks].join(" of ")
            : "1"
          : this.numWorks > 1
          ? [1, this.numWorks].join(" to ")
          : "1";
      const workLabel = [workWord, numPart].join(": ");
      if (this.numWorks > 0 && this.enableContainers) {
        items.push({
          name: workLabel,
          key: `works`,
          active: this.workIndex >= 0,
          icon: "",
        });
      }
      if (this.numWorks > 1 && this.enableContainers) {
        items.push({
          name: `next`,
          key: `next`,
          active: false,
          icon: "arrow-right-bold",
        });
      }
      if (this.numWorks < this.maxWorks && !this.showNewWork && this.enableContainers) {
        items.push({
          name: this.site.label("submission__add_work_label"),
          key: "add_work",
          active: this.showOverview,
          icon: "plus",
        });
      }

      if (this.numWorks > 1 && this.enableContainers) {
        items.push({
          name: this.site.label("submission__order"),
          key: `sort`,
          active: this.showSort,
          icon: "sort",
        });
      }
    }
    // Show overview link if at least one valid container (work) is present or when containers arew disabled if there's at least one valid statement
    if (this.numWorks > 0 || (!this.enableContainers && this.hasOneStatement)) {
      items.push({
        name: this.site.label("completion__title"),
        key: "overview",
        active: this.showOverview,
        icon: "",
      });
    }
    return items;
  }

  /* Only saved work items, used for sorting */
  get submissionWorkItems() {
    return this.workItems
      .filter((w) => notEmptyString(w.id, 12))
      .map((work, wi) => {
        return {
          name: `${wi + 1}: ${work.title}`,
          key: `work-${work.id}-${wi}`,
          active: this.workIndex === wi && !this.showOverview,
          icon: "",
        };
      });
  }

  /* Should the work form be available */
  get showWork() {
    return this.workIndex >= 0 && !this.showOverview && this.mayEdit && this.enableContainers;
  }

  get hasOneStatement() {
    return this.submission.statements.some(st => notEmptyString(st.text, 3) || notEmptyString(st.image, 9));
  }

  get wrapperClasses() {
    const cls = [];
    if (this.uploadRef.length > 3) {
      cls.push("show-upload");
    }
    if (this.showStart) {
      cls.push("show-start");
    }
    if (this.workIndex >= 0) {
      cls.push("show-work");
    }
    if (this.showOverview) {
      cls.push("show-overview");
    }
    if (this.showSort) {
      cls.push("show-sort");
    }
    if (this.showIneligible) {
      cls.push("ineligible-mode");
    }
    return cls;
  }

  get actionClasses() {
    return this.changeDetected
      ? ["changed"]
      : this.changeChecked
      ? ["not-changed"]
      : [];
  }

  get hasWorkItems() {
    return this.workItems.length > 0;
  }

  get showUploadForm() {
    return this.uploadRef.length > 3;
  }

  get requireSponsorUrl() {
    return requireSponsorUrl;
  }

  get maxTags() {
    const max = this.site.settings.get("max_tags_per_work");
    return typeof max === "number" ? max : 4;
  }

  get maxDisplayTitleLength() {
    return this.isGroupMode ? 100 : 60;
  }

  registerChange(e) {
    const { target } = e;
    if (
      ["input", "textarea", "select", "option", "button"].includes(
        target.tagName.toLowerCase()
      ) ||
      target.classList.contains("ql-editor")
    ) {
      if (!this.changeDetected) {
        this.detectChange();
      }
      bus.$emit("active", true);
    } else {
      this.checkForChanges();
    }
    bus.$emit("form-click", e);
  }
  
  checkForChanges() {
    if (!hasErrorInSection()) {
      this.saveLocked = false;
    }
  }

  detectChange() {
    if (!this.detecting) {
      this.detecting = true;
      if (this.hasChanged()) {
        this.changeDetected = true;
      }
      this.checkForChanges();
      setTimeout(() => {
        this.detecting = false;
      }, 125);
    }
  }

  addWork() {
    if (
      !this.saving &&
      this.workIndex < this.numWorks &&
      this.numWorks <= this.maxWorks
    ) {
      this.saving = true;
      this.showNewWork = true;
      this.workIndex = this.numWorks;
      setTimeout(() => {
        this.saving = false;
      }, 1000);
      bus.$emit("active", true);
    }
  }

  sync() {
    const submission = this.$ls.get("submission");
    if (submission instanceof Object) {
      this.assignSubmission(submission);
      this.mapLinkFields("links");
      this.mapLinkFields("sponsors");
      this.syncMemberFields();
      const project = this.$ls.get('project');
      if (project instanceof Object) {
        this.assignProject(project);
      }
      this.courseItem.name = this.submission.course;
      this.courseItem.code = this.submission.courseCode;
      this.contactFields =
        this.submission.contacts.length > 0
          ? this.submission.contacts
          : [new Contact()];
      const profileObj = extractProfileObject(this.submission as Submission);
      this.$ls.set("profile", profileObj);
      const isNewProjectSlug = /^-?new-project-?$/i.test(this.submission.slug);
      this.slugLocked = notEmptyString(this.submission.slug, 5) && !isNewProjectSlug; // unlocked initially or if < 5 chars long
      //  && sanitize(this.submission.displayName).substring(0, 16) === this.submission.slug.substring(0, 16)
      if (notEmptyString(this.submission.displayName, 3) && this.submission.displayName.includes("[") === false) {
        const newSlug = sanitize(this.submission.displayName, this.maxSlugLength);
        if ((newSlug !== this.submission.slug && this.submission.slug.length < 9) || this.submission.slug.length < 3 || isNewProjectSlug) {
          this.slugLocked = false;
          if (isNewProjectSlug) {
            this.submission.slug = '';
          }
        }
      }
    }
  }

  hasChanged() {
    const profileObj = this.$ls.get("profile");
    if (profileObj instanceof Object) {
      const newObj = extractProfileObject(this.submission as Submission);
      this.changeChecked = true;
      const isSame = deepEqual(profileObj, newObj);
      if (!isSame) {
        this.$ls.set("profile", newObj);
      }
      return !isSame;
    }
    return true;
  }

  mapLinkFields(name: string) {
    const tempField = name.replace(/s$/, "Fields");
    const refField = this.submission[name];
    if (refField instanceof Array) {
      this[tempField] = refField.length > 0 ? refField : [new Link()];
    }
  }

  syncMemberFields() {
    this.memberFields = this.submission.members instanceof Array && this.submission.members.length > 0 ? this.submission.members.filter(member => validEmail(member.identifier)) : [];
    if (this.memberFields.length < 1) {
      this.memberFields.push(new Member())
    }
  }

  saveDetailsMain() {
    const info = validateSectionDom();
    if (info.invalid) {
      this.applySaveLock(info);
    } else {
      this.saveDetails(false);
      this.dismissMsg();
    }
  }

  matchesCurrentUserIdentifier(email = '') {
    return notEmptyString(email) && notEmptyString(this.user.identifier) && email.toLowerCase() == this.user.identifier.toLowerCase();
  }

  syncMembersWithSubmission() {
    const hasLead = this.memberFields.some(m => this.matchesCurrentUserIdentifier(m.identifier));
    const emails: string[] = [];
    const members: Member[] = [];
    for (const m of this.memberFields) {
      if (validEmail(m.identifier) && notEmptyString(m.displayName) && emails.includes(m.identifier.toLowerCase()) === false) {
        members.push(m);
        emails.push(m.identifier.toLowerCase());
      }
    }
    if (!hasLead) {
      if (validEmail(this.user.identifier)) {
        members.unshift(new Member({
          identifier: this.user.identifier,
          displayName: this.user.fullName,
        }));
      }
    }
    this.submission.members = members;
  }

  saveDetails(skipToast = false) {
    if (!this.saving && this.changeDetected && !this.showIneligible) {
      this.changeDetected = false;
      this.saving = true;
      this.submission.links = this.submission.links.filter(validLinkField);
      const sponsorLinkValidator = requireSponsorUrl
        ? validLinkField
        : notEmptyLinkField;
      this.submission.sponsors = this.submission.sponsors.filter(
        sponsorLinkValidator
      );
      if (this.isGroupMode) {
        this.syncMembersWithSubmission();
      }
      this.submission.contacts = this.submission.contacts.filter(validContact);
      
      if (!this.courseFieldsLocked) {
        const course = this.courses.find(
          (c) => c.code === this.courseItem.code
        );
        if (course instanceof Object) {
          this.submission.course = course.name;
          this.submission.courseCode = course.code;
        }
      }
      if (this.isGroupMode && emptyString(this.submission.slug) && notEmptyString(this.submission.displayName)) {
        this.submission.slug = sanitize(this.submission.displayName, this.maxSlugLength);
      }
      const duration = skipToast ? 0 : 3000;
      if (this.isGroupMode && !this.showSlugError && this.slugLocked) {
        this.checkSlug(true, duration);
      } else {
        this.save(duration);
      }
    }
  }

  save(duration = 3000, textMsg = "", skipWorks = true) {
    bus.$emit("active", true);
    this.changeDetected = false;
    this.$ls.set("submission", this.submission);
    if (this.prevKey === "start") {
      this.sync();
    }
    this.submission.mode = this.mode;
    if (captureHashTags && enableProfileTags) {
      this.updateTags();
    }
    const mayRemoveCourse = (!this.showCourses && notEmptyString(this.submission.programmeCode, 5) && !this.mayNotEditCourse);
    const hasCourseCode = validCourseCode(this.submission.courseCode) || mayRemoveCourse;
    if (mayRemoveCourse && !this.showCourses) {
      this.submission.courseCode = '---';
    }
    const hasProgrammeFields = notEmptyString(this.submission.programmeCode, 4) && notEmptyString(this.submission.school, 3);
    const programmeOverride = (!this.programmeLocked && hasProgrammeFields);
    const programmeAndSchoolLocked = this.programmeFieldsLocked && !programmeOverride;
    saveSubmission(
      this.submission,
      programmeAndSchoolLocked,
      !hasCourseCode,
      skipWorks
    ).then((data) => {
      if (data.valid) {
        this.showNewWork = false;
        const { modifiedAt } = data.submission;
        if (modifiedAt) {
          this.submission.modifiedAt = new Date(modifiedAt);
        }
        // if duration > 0 show toast. Use default message if no override in textMsg is available
        const msg =
          duration > 0
            ? notEmptyString(textMsg)
              ? textMsg
              : this.site.label("submission__saved")
            : "";
        if (duration > 0) {
          this.toast(msg, duration);
        }
        setTimeout(() => {
          this.saving = false;
        }, 1000);
      } else if (data.isNewer) {
        this.resyncConfirm();
      }
    });
    setTimeout(() => {
      this.saving = false;
    }, 6000);
  }

  escape(resetSort = true) {
    this.uploadRef = "";
    this.mediaItemId = "";
    if (resetSort) {
      this.showSort = false;
    }
  }

  closeAlert() {
    if (this.dialogue instanceof Object) {
      if (this.dialogue.close instanceof Function) {
        this.dialogue.close();
      }
    }
  }

  escapeAll() {
    this.escape(true);
    this.closeAlert();
  }

  resyncConfirm() {
    const message = this.site.label("submission__updated_elsewhere");
    /* const title = `Synchronise your submission`;
    const question = confirm? `Confirm?` : `Do you want to load remote changes`; */
    this.$buefy.dialog.confirm({
      message,
      type: "is-warning",
      hasIcon: true,
      icon: "trash-can-outline",
      onConfirm: () => this.resync(),
    });
  }

  resync() {
    checkRemoteUpdatedSub(this.submission._id, this.submission.modifiedTs).then(
      (data) => {
        if (data.isNewer && data.submission instanceof Object) {
          this.assignSubmission(data.submission);
        }
      }
    );
  }

  setUploadRef(refKey = "", mediaItemId = "", mode = "media") {
    this.uploadRef = refKey;
    if (notEmptyString(mediaItemId)) {
      this.mediaItemId = mediaItemId;
      this.uploadMode = mode;
    } else {
      this.mediaItemId = "";
      this.uploadMode = "media";
    }
  }

  toast(message: string, duration = 5000, type = "success") {
    if (!this.showingToast) {
      const numTst = document.querySelectorAll('.notices .toast').length;
      if (numTst < 1) {
        this.showingToast = true;
        this.$buefy.toast.open({
          duration,
          message,
          position: "is-bottom",
          type: ["is", type].join("-"),
        });
        setTimeout(() => {
          this.showingToast = false;
        }, duration + 2000);
      }
    }
  }

  alertMsg(message = '', typeWord = 'danger') {
    setTimeout(() => {
      bus.$emit("open-help", "all");
      const sbLen = document.querySelectorAll('.dialog').length;
      if (sbLen < 1 && !this.showingToast) {
        this.showingToast = true;
        this.dialogue = this.$buefy.dialog.alert({
          title: 'Alert',
          message,
          confirmText: 'Dismiss',
          type: `is-${typeWord}`,
        });
        setTimeout(() => {
          this.showingToast = false;
        }, 2000);
      }
    }, 200);
  }

  addLink(field: string) {
    if (!hasErrorInSection() && this.numEmptyLinks < 1) {
      switch (field) {
        case "links":
          this.linkFields.push(new Link());
          break;
        case "sponsors":
          this.sponsorFields.push(new Link());
          break;
      }
    }
  }

  get numEmptyLinks() {
    return this.submission.links.filter(lk => emptyString(lk.url, 4)).length;
  }

  get hasProject() {
    return this.site.project instanceof Object && this.site.project.exists === true;
  }

  get project() {
    return this.hasProject ? this.site.project : {...defaultSimpleProject };
  }

  addMember() {
    this.memberFields.push(new Member());
  }

  addContact() {
    this.contactFields.push(new Contact());
  }

  applySaveLock(info: ErrorInfo) {
    const labelKey = info.hasErrors
      ? "submission__check_errors"
      : "work__add_title";
    const message = this.site.label(labelKey);
    if (info.untitled) {
      bus.$emit("add-work-title-error");
    }
    this.showWarning(message, info.hasErrors);
    this.saveLocked = true;
    setTimeout(() => {
      this.saveLocked = false;
    }, 15000);
  }

  showWarning(message, scrollMode = false) {
    if (scrollMode) {
      this.alertMsg(message);
      this.goToError();
    } else {
      this.alertMsg(message, 'danger');
    } 
  }

  dismissMsg() {
    this.saveLocked = false;
    this.closeAlert();
  }

  goTo(key: string, keepOpen = false, skipValidate = false) {
    let ok = skipValidate;
    if (notEmptyString(this.submission.slug) && !this.showSlugError) {
      this.slugLocked = true;
    }
    const fromPreview = this.$route.path.includes("overview");
    if (!ok) {
      const info = validateSectionDom();
      if (info.invalid) {
        this.applySaveLock(info);
      } else {
        ok = true;
      }
    }
    if (ok) {
      this.goToOk(key, keepOpen, fromPreview);
      this.dismissMsg();
      // this.disableEvents();
    }
  }

  goToError() {
    const errorEl = document.querySelector('.field.error');
    if (errorEl instanceof Element) {
      if (errorEl.parentNode.parentNode instanceof Element) {
        this.$scrollTo(errorEl.parentNode.parentNode, {offset: -72});
      }
    }
    
  }

  goToOk(key: string, keepOpen = false, fromPreview = false) {
    let newPath = "/";
    const currNumWorks = this.numWorks;
    this.mediaItemId = "";
    this.changeDetected = false;
    if (notEmptyString(this.workId, 12) && ["start"].includes(key) === false) {
      bus.$emit("save-work", { workId: this.workId });
    } else if (this.prevKey === "start") {
      this.changeDetected = true;
      this.saveDetails(true);
    }
    switch (key) {
      case "start":
        this.workIndex = -1;
        this.showOverview = false;
        this.showSort = false;
        newPath = "/start";
        break;
      case "overview":
        this.workIndex = this.numWorks - 1;
        this.showOverview = true;
        this.showSort = false;
        newPath = "/overview";
        break;
      case "add_work":
        if (this.showNewWork) {
          this.addWork();
        }
        newPath = this.goToWork(`work-new-${currNumWorks}`);
        this.showSort = false;
        this.showOverview = false;
        break;
      case "sort":
        this.showSort = !this.showSort;
        setTimeout(() => {
          if (this.showSort) {
            this.scrollTop();
          }
        }, 280);
        break;
      default:
        newPath = this.goToWork(key, fromPreview);
        this.showSort = keepOpen;
        break;
    }
    const { path, query } = this.$route;
    if (path !== newPath && newPath.length > 2 && !this.redirecting) {
      this.prevKey = newPath.substring(1);
      this.redirecting = true;
      this.$router.push({
        path: newPath,
        query,
      });
      this.scrollTop();
      setTimeout(() => {
        this.redirecting = false;
      }, 250);
    }
  }

  goToWork(key: string, fromPreview = false, delay = 450) {
    const [part, workId, index] = key.split("-");
    let isWork = false;
    let np = "";
    let tgIndex = -1;
    const numWorkContainers = this.showNewWork
      ? this.numWorks + 1
      : this.numWorks;
    switch (part) {
      case "prev":
        tgIndex = fromPreview ? this.workIndex : this.workIndex - 1;
        isWork = tgIndex >= 0;
        break;
      case "next":
        tgIndex = this.workIndex + 1;
        isWork = tgIndex < numWorkContainers;
        break;
      case "works":
        tgIndex = this.workIndex > 0 ? this.numWorks - 1 : 0;
        isWork = tgIndex < numWorkContainers;
        break;
      case "work":
        isWork = true;
        tgIndex = parseInt(index);
        break;
    }
    if (notEmptyString(workId)) {
      this.showSort = false;
    }
    this.showOverview = false;
    // add delay to ensure previous work has saved
    let newWorkIndex = -2;
    if (isWork) {
      np = "/work/" + (tgIndex + 1);
      newWorkIndex = tgIndex;
    } else if (tgIndex < 0) {
      np = "/work/" + numWorkContainers;
      newWorkIndex = numWorkContainers - 1;
    } else if (tgIndex >= numWorkContainers && numWorkContainers > 0) {
      np = "/work/1";
      newWorkIndex = 0;
    }
    // now set the new work index
    setTimeout(() => {
      if (newWorkIndex > -2) {
        this.workIndex = newWorkIndex;
      }
    }, delay);
    return np;
  }

  findStatement(type: string) {
    return this.submission instanceof Submission
      ? this.submission.findStatement(type)
      : new Statement();
  }

  retrieveTags() {
    fetchTags().then((data) => {
      if (data instanceof Array) {
        this.tagList = data;
      }
    });
  }

  scrollTop() {
    const cancelScroll = this.$scrollTo("#nav-bar");
    setTimeout(() => {
      if (cancelScroll) {
        if (typeof cancelScroll === "function") {
          cancelScroll();
        }
      }
    }, 500);
  }

  get workId() {
    if (this.workIndex >= 0 && this.workIndex < this.numWorks) {
      if (this.submission.works[this.workIndex] instanceof Work) {
        return this.submission.works[this.workIndex]._id;
      }
    }
    return "-";
  }

  get workNum() {
    return this.showOverview
      ? this.numWorks
      : this.workIndex >= 0
      ? this.workIndex + 1
      : 1;
  }

  studentProgrammeFieldsLocked() {
    const hasSchool = notEmptyString(this.submission.school, 3);
    const hasProgramme = notEmptyString(this.submission.programme, 3);
    const hasProgrammeCode = notEmptyString(this.submission.programmeCode, 3);
    return hasSchool && hasProgramme && hasProgrammeCode && !this.programmeLocked;
  }

  get programmeFieldsLocked() {
    return this.isGroupMode || this.studentProgrammeFieldsLocked();
  }

  get courseFieldsLocked() {
    return this.isGroupMode || (
      this.submission.submitted && notEmptyString(this.submission.courseCode, 2)
    );
  }

  get numWorks() {
    return this.submission.works.length;
  }

  get numWorkRefs() {
    return this.workItems.length;
  }

  get showWebTransferPane() {
    return (
      !this.showStart &&
      !this.showOverview &&
      this.workIndex >= 0 &&
      this.uploadMode !== "pdf"
    );
  }

  get statementItems() {
    return statements.filter(st => st instanceof Object && notEmptyString(st.type));
  }

  unlockProgramme() {
    this.programmeLocked = false;
  }



  updateMember(inData = null, index = 0) {
    if (inData instanceof Object && index >= 0 && index < this.memberFields.length) {
      const keys = Object.keys(inData);
      if (keys.length > 1) {
        const hasIdentifier = keys.includes("identifier") && notEmptyString(inData.identifier, 5);
        if (!hasIdentifier) {
          inData.identifier = this.memberFields[index].identifier;
        }
        this.memberFields[index] = new Member(inData);
      }
    }
  }

  checkSlug(save = false, duration = 0) {
    this.showSlugError = false;
    testSlug(this.submission.slug, this.submission._id).then(data => {
      if (!data.valid) {
        this.showSlugError = true;
        this.slugLocked = false;
      } else {
        this.showSlugError = false;
        if (save === true) {
          this.save(duration)
        }
      }
    });
  }

  cleanSlug() {
    this.submission.slug = sanitize(this.submission.slug, this.maxSlugLength);
  }

  updateSlug() {
    const displayNameLen = this.submission.displayName.length;
    let slugLen = this.submission.slug.length;
    if (this.showSlugField && !this.slugLocked && displayNameLen > 2) {
      this.submission.slug = sanitize(this.submission.displayName,this.maxSlugLength);
      slugLen = this.submission.slug.length;
    }
    if (slugLen < 5 || (displayNameLen < 9 && this.slugLocked)) {
      const newSlug = sanitize(this.submission.displayName, this.maxSlugLength);
      if (newSlug !== this.submission.slug) {
        this.slugLocked = false;
        this.submission.slug = newSlug;
        this.checkSlug();
      }
    }
  }

  @Watch("courseItem.code")
  changeCourseItemCode(newVal) {
    const cItem = this.courses.find(r => r.code === newVal)
    if (cItem instanceof Object) {
      this.submission.courseCode = newVal;
      this.submission.course = cItem.name;
    } else {
      this.submission.courseCode = "";
      this.submission.course = "";
    }
  }

  @Watch("submission", { deep: true })
  changeSubmission(newVal, oldVal) {
    if (this.hasProgramme) {
      const row = this.site.programmes.find(p => p.key === this.submission.programmeCode);
      if (row instanceof Object) {
        this.submission.programme = row.name;
      }
    }
    
    if (!this.slugLocked && oldVal instanceof Object) {
      const oldSlug = oldVal.slug;
      const oldT = oldVal.displayName;
      const newSlug = newVal.slug;
      const newT = newVal.displayName;
      if (newSlug === oldSlug && oldT !== newT) {
        this.submission.slug = sanitize(this.submission.displayName);
      }
    }
    this.detectChange();
  }
}
